'use client';

import { EmailForm } from './EmailForm';
import { TargetIcon, ZapIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';

interface FeatureHighlightProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

function FeatureHighlight({ title, description, icon }: FeatureHighlightProps) {
  return (
    <div className="flex items-start space-x-4">
      <div className="text-2xl text-primary-DEFAULT2">{icon}</div>
      <div>
        <h3 className="font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
}

export function CTASection() {
  const features = [
    {
      icon: <TargetIcon className="h-8 w-8" />,
      title: "Personalized Magic",
      description: "Stories uniquely crafted around your child's world - their interests, name, and adventures"
    },
    {
      icon: <ZapIcon className="h-8 w-8" />,
      title: "AI-Powered Storytelling, Instantly",
      description: "Generate captivating, original stories in seconds – no more bedtime prep stress!"
    },
    {
      icon: <ShieldCheckIcon className="h-8 w-8" />,
      title: "Safe & Expert-Approved",
      description: "Every story is crafted with child development best practices and parent-approved content"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-[#FFE5D9]/20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 p-8 md:p-12">
            <div className="space-y-6">
              <h2 className="font-serif text-3xl sm:text-4xl font-bold bg-gradient-to-r from-[#FF8B6B] to-[#FF5D3A] bg-clip-text text-transparent">
                Ready to Transform Bedtime?
              </h2>
              <p className="text-lg text-gray-600">
                Join Our Early Access List Today!
              </p>
              <div className="space-y-6">
                {features.map((feature, index) => (
                  <FeatureHighlight
                    key={index}
                    icon={feature.icon}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>
            </div>
            <div className="flex flex-col justify-center space-y-6 bg-[#FFE5D9]/10 rounded-2xl p-8">
              <div className="text-center space-y-4">
                <h3 className="text-2xl font-bold text-gray-900">
                  Get Early Access
                </h3>
                <p className="text-gray-600">
                  Limited spots available - Join now to secure your place!
                </p>
              </div>
              <EmailForm ctaText="Get Early Access - Join Waitlist Now" />
              <p className="text-sm text-center text-gray-500">
                <SparklesIcon className="inline-block h-4 w-4 mr-1" /> Free to Join • No Credit Card Required
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 